import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "assets/jss/material-dashboard-react.js";

const dashboardStyle = {
  successText: {
    color: successColor[0]
  },
  upArrowCardCategory: {
    width: "16px",
    height: "16px"
  },
  stats: {
    color: grayColor[0],
    display: "inline-flex",
    fontSize: "11px",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "15px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    }
  },
  cardCategory: {
    color: grayColor[0],
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0"
  },
  cardCategoryWhite: {
    color: "rgba(" + hexToRgb(whiteColor) + ",.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitle: {
    color: grayColor[2],
    marginTop: "3px",
    minHeight: "auto",
    fontWeight: "500",
    fontFamily: 'Montserrat, sans-serif',
    marginBottom: "3px",
    textDecoration: "none",
    fontSize: "100%",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      fontSize: "80%",
      lineHeight: "1"
    }
  },
  cardTitleWhite: {
    color: whiteColor,
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: grayColor[1],
      fontWeight: "400",
      lineHeight: "1"
    }
  },
  cardMensagem: {
    fontFamily: 'Montserrat, sans-serif',
    color: grayColor[1],
    fontWeight: "400",
    margin: "0",
    fontSize: "100%",
    marginTop: "0",
    paddingTop: "10px",
    marginBottom: "0"
  },
  
  cardBottom: {
    color: grayColor[0],
    display: "inline-flex",
    fontSize: "13px",
    fontWeight: "500",
    "& svg": {
      top: "4px",
      width: "16px",
      height: "16px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    },
    "& .fab,& .fas,& .far,& .fal,& .material-icons": {
      top: "4px",
      fontSize: "15px",
      position: "relative",
      marginRight: "3px",
      marginLeft: "3px"
    }
  },
  card: {
    boxShadow: 'none',
    backgroundColor: '#FFF',
    paddingTop: '20px',
    paddingBottom: '20px !important',
    borderTop: '5px solid #03A9F4!important',
  },
  boxIcon: {
    marginTop: '0 !important',
    borderRadius: '45px !important',
    boxShadow: 'none'
  }
};

export default dashboardStyle;
